/*
 * @Author: Gavin Chan
 * @Date: 2021-09-07 22:16:09
 * @LastEditors : Please set LastEditors
 * @LastEditTime: 2025-06-12 14:28:35
 * @FilePath     : \examinee_web\src\http\api\user.ts
 * @Descriptions: todo
 */
import { RequestEnum, ServiceGateWay } from "@/utils/enum";
import $http from "@/utils/request";
import qs from "qs";
const REGISTERED = `${ServiceGateWay.REGISTEREDUSER}`;
const USER = `${REGISTERED}/RegisteredUserExamer`;
const RealNameAuthenticationExamer = `${ServiceGateWay.REGISTEREDUSER}/RealNameAuthenticationExamer`;
const NOTIFICATIONMESSAGE = `${ServiceGateWay.NOTIFICATIONMESSAGE}`;

const Authentication = {
  GET: {
    /**
     * @description  : 微信鉴权：绑定微信授权Code（扫码关注微信公众号用）
     * @param         {any} param
     * @return        {*}
     */
    getBindCode(code: any, tenantId: string) {
      return $http({
        url: `${NOTIFICATIONMESSAGE}/examinee/message/OpenId/${code}`,
        options: {
          tenantId
        }
      });
    },
    /**
     * @description  : 微信鉴权：绑定微信授权OpenId（扫码关注微信公众号用）
     * @param         {any} param
     * @return        {*}
     */
    getBindOpenId(openId: any, tenantId) {
      return $http({
        url: `${REGISTERED}/RegisteredUserExamer/BindOpenId/${openId}`,
        options: {
          tenantId
        }
      });
    },
    /**
     * @description  : 考生端获取当前实名认证方式以及配置
     * @param         {*}
     * @return        {*}
     */
    getRealNameAuthConfig(tenantId) {
      return $http({
        url: `${RealNameAuthenticationExamer}`,
        options: {
          tenantId
        }
      });
    }
  },
  POST: {
    /**
     * @description  : 考生端获取当前的实名信息
     * @param         {*}
     * @return        {*}
     */
    getRealNameInfo(strings: string[], tenantId) {
      const ps = qs.stringify({ ps: strings }, { indices: false, arrayFormat: "repeat" });
      return $http({
        url: `${RealNameAuthenticationExamer}/RealNameInfo?${ps}`,
        method: RequestEnum.POST,
        options: {
          tenantId
        }
      });
    },
  },

  PATCH: {
    patchAuthentication(data: any, tenantId) {
      return $http({
        url: `${REGISTERED}/RegisteredUserExamer`,
        method: RequestEnum.PATCH,
        data,
        options: {
          noTransform: true,
          tenantId
        }
      });
    },
    // 合并账号
    combinedAccount(idCard: string, tenantId) {
      return $http({
        url: `${REGISTERED}/RegisteredUserExamer/${idCard}`,
        method: RequestEnum.PATCH,
        options: {
          tenantId
        }
      });
    },
    //验证新手机（验证码）
    changePhone(data: any, tenantId) {
      return $http({
        url: `${REGISTERED}/RecoverUserExamer/ChangePhone`,
        method: RequestEnum.PATCH,
        data: data,
        options: {
          noTransform: true,
          tenantId
        }
      });
    },
    // 修改手机号码（通过注册身份证信息）
    changePhoneBySecurityCode(data: any, tenantId) {
      return $http({
        url: `${USER}/ChangePhoneBySecurityCode`,
        method: RequestEnum.PATCH,
        data: data,
        options: {
          noTransform: true,
          tenantId
        }
      });
    }
  },
};

const User = {
  POST: {
  },
  PATCH: {
    // 用户自主修改密码
    updatePassword(data, tenantId?) {
      return $http({
        url: `${REGISTERED}/RecoverUserExamer/ModifyPassword`,
        method: RequestEnum.PATCH,
        data,
        options: {
          tenantId
        }
      });
    },
  },
};

export default { Authentication, User };
